// @flow

import * as React from 'react';

import { Svg, Text } from '@gandi/ui';

import styles from './Breadcrumb.scss';

export function PathSeparator(): React.Element<typeof Svg> {
  return (
    <Svg name="chevronRight" theme="grey" className={styles.pathSeparator} />
  );
}

type Props = {|
  path?: Array<string>,
|};

function Breadcrumb({ path = [] }: Props): Array<React.Element<'span'>> {
  return path.map<React.Element<'span'>, void>(
    (subpath: string, index: number) => (
      <span key={subpath}>
        {index > 0 && <PathSeparator />}
        <Text>{subpath}</Text>
      </span>
    )
  );
}

export default Breadcrumb;
